import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { DataType, PagedContentConfiguration, PagedContentType, TableColumnDefinition } from '@sdbn/common';
import { Equipment, EquipmentAttributeValue, EquipmentType } from '../../../common/equipment.model';
import { FormularDetailLayoutItemProvider, DetailLayout } from '@sdbn/common';
import { v4 as uuidv4 } from 'uuid';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-equipment-admin-instances',
    templateUrl: './equipment-admin-instances.component.html',
    styleUrls: ['./equipment-admin-instances.component.scss'],
    standalone: false
})
export class EquipmentAdminInstancesComponent implements OnInit, AfterViewChecked {

  itemProvider = new FormularDetailLayoutItemProvider();

  configuration = new PagedContentConfiguration({
    columns: [
      new TableColumnDefinition({
        dictionaryKey: 'Identifier',
        type: DataType.STRING,
        identifier: 'identifier'
      })
    ],
    itemDataAccessor: {
      getTitle: (item: any) => item['identifier'],
      getSubtitle: (item: any) => null,
      getIcon: (item: any) => null
    },
    desktopType: PagedContentType.SIDE_TAB_SINGLE,
    mobileType: PagedContentType.ICON_MENU_SINGLE
  });

  currentLayoutString = '';
  layout = new DetailLayout();

  equipmentType: EquipmentType;

  currentInstance: Equipment;

  currentInstanceDetails: any;

  formGroup = new FormGroup({
    identifier: new FormControl(null, [Validators.required]),
    disabled: new FormControl(false, [])
  });

  @Input('equipmentType') set setEquipmentType(value: EquipmentType) {

    this.equipmentType = value;

    if (this.equipmentType?.attributeDefinition != null) {
      this.currentLayoutString = this.equipmentType.attributeDefinition;
      this.layout = new DetailLayout(JSON.parse(this.equipmentType.attributeDefinition));
    } else {
      this.currentLayoutString = '';
      this.layout = new DetailLayout();
    }

    if (this.equipmentType?.equipments?.length > 0) {
      this.onSelectionChanges(this.equipmentType.equipments[0]);
    } else {
      this.onSelectionChanges(null);
    }
  }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {
      if (this.currentInstance != null) {
        this.currentInstance.identifier = value.identifier;
        this.currentInstance.disabled = value.disabled;
      }
    });

  }

  /* needed for mask definition changes, as component still exists */
  ngAfterViewChecked(): void {
    if (this.equipmentType?.attributeDefinition != null && this.currentLayoutString !== this.equipmentType.attributeDefinition) {
      this.currentLayoutString = this.equipmentType.attributeDefinition;
      this.layout = new DetailLayout(JSON.parse(this.equipmentType.attributeDefinition));
    }
  }

  public onAddRequested() {
    let equipment = new Equipment({ id: uuidv4(), identifier: '<new Instance>' });
    this.equipmentType.equipments.push(equipment);
    this.onSelectionChanges(equipment);
  }

  onDeleteRequested(selectedItem: Equipment) {
    this.equipmentType.equipments.splice(this.equipmentType.equipments.findIndex( instance => instance === selectedItem), 1);
    
  }

  onSelectionChanges(selectedItem: Equipment) {

    this.currentInstance = selectedItem;

    this.formGroup.patchValue({ identifier: this.currentInstance?.identifier, disabled: this.currentInstance?.disabled });

    this.currentInstanceDetails = {};
    if (this.currentInstance != null) {
      for (const value of this.currentInstance.values) {
        this.currentInstanceDetails[value.key] = value.value;
      }
    }
  }

  public handleMaskChanged() {
    Object.keys(this.currentInstanceDetails).forEach(key => {
      console.log('handleMaskChanged', this.currentInstance, this.currentInstanceDetails);
      if (this.currentInstance != null) {
        let value = this.currentInstance?.values.find(v => v.key === key);
        if (value == null) {
          value = new EquipmentAttributeValue();
          this.currentInstance.values.push(value);
          value.key = key;
        }

        value.value = this.currentInstanceDetails[key];
      }
    });
  }

}
